import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CreatorCallToActionComponent } from './creator-call-to-action.component';
import { LoginModule } from '../shared/transact-auth/transact-auth.module';
import { NotdPartnersModalModule } from '../shared/notd-partners-modal/notd-partners-modal.module';

@NgModule({
    declarations: [ CreatorCallToActionComponent ],
    imports: [
        CommonModule,
        RouterModule,
        LoginModule,
        NotdPartnersModalModule
    ],
    exports: [ CreatorCallToActionComponent ]
})

export class CreatorCallToActionModule {}
